import { useEffect, useRef } from 'react';

import { send } from '@actual-app/core/platform/client/connection';
import { q } from '@actual-app/core/shared/query';

import { useMetadataPref } from '#hooks/useMetadataPref';
import { saveSyncedPrefs } from '#prefs/prefsSlice';
import { aqlQuery } from '#queries/aqlQuery';
import { useDispatch, useSelector } from '#redux';

import { travesiaNueva } from './estado';
import { barcoSinEstrenar } from './recuperar';

async function contar(tabla: 'accounts' | 'transactions'): Promise<number> {
  const { data } = await aqlQuery(q(tabla).calculate({ $count: '*' }));
  return Number(data) || 0;
}

/**
 * Si el barco abierto no tiene pref `travesia` pero está sin estrenar
 * (`barcoSinEstrenar`), deja la travesía pendiente para que Gavi salga.
 * Se mira una vez por barco y nunca en uno de «Solo ver».
 */
export function useRecuperarTravesia(activo: boolean) {
  const dispatch = useDispatch();
  const [id] = useMetadataPref('id');
  const [soloLectura] = useMetadataPref('rumboSoloLectura');
  const raw = useSelector(state => state.prefs.synced.travesia);
  const mirado = useRef<string | null>(null);

  useEffect(() => {
    if (!activo || !id || raw || soloLectura || mirado.current === id) {
      return;
    }
    mirado.current = id;
    void (async () => {
      try {
        const [{ grouped }, cuentas, movimientos] = await Promise.all([
          send('get-categories'),
          contar('accounts'),
          contar('transactions'),
        ]);
        if (barcoSinEstrenar({ grupos: grouped, cuentas, movimientos })) {
          await dispatch(
            saveSyncedPrefs({ prefs: { travesia: travesiaNueva() } }),
          );
        }
      } catch {
        // Si no se puede mirar, el barco sigue como estaba.
      }
    })();
  }, [activo, id, raw, soloLectura, dispatch]);
}
